
import * as React from 'react';
import { Dispatch, Action } from 'redux';
import { connect } from 'react-redux';
import * as H from 'history';
import { Typography, Paper, Button } from '@material-ui/core';
import 'cropperjs/dist/cropper.css';
import CloudUpload from '@material-ui/icons/CloudUpload';
import DeleteForever from '@material-ui/icons/DeleteForever';
import Print from '@material-ui/icons/Print';
import { IAppState, kansatsuKirokuOperations } from '../redux/modules';
import { CloseBackButton } from './parts/CloseBackButton';
import { SiteInfoListState } from '../redux/modules/siteInfoList';
import { SiteInfo } from '../models/SiteInfo';
import { InferenceResultView } from './parts/InferenceResultView';
import { KansatsuKirokuState } from '../redux/modules/kansatsuKiroku';
import { KansatsuKiroku } from '../models/KansatsuKiroku';
import KansatsuKirokuEdit from './parts/KansatsuKirokuEdit';
import * as moment from 'moment';
import ReactToPrint from 'react-to-print';
import { PrintKansatsuKiroku } from './PrintKansatsuKiroku';

const styles = {
  contentBase: {
    padding: '20px',
    marginBottom: '20px'
  }
};

interface OwnProps {
  match: any; // withRouterにより設定される
  sites: SiteInfoListState;
  clear: () => void;
  history: H.History;
  reset: () => any;
  getRecord: ({ koujiBangou, key, completeHandler }
      :{ koujiBangou: string, key: string, completeHandler: () => any }) => any;
  postRecord: (record: KansatsuKiroku, completeHandler: () => any) => any
  kansatsuKiroku: KansatsuKirokuState;
}

interface OwnState {
  // 工事現場の情報
  site: SiteInfo | undefined;
};

class EditKansatsuKirokuPage extends React.Component<OwnProps, OwnState>{
  private kansatsuKirokuEditElement: KansatsuKirokuEdit;
  // 印刷対象Elementへの参照
  private printTargetRef;
  constructor(props: OwnProps) {
    super(props);
    this.state = {
      site: undefined
    };
  }

  componentDidMount() {
    // このページの工事番号
    const koujiBangou = this.props.match.params.koujibangou;
    // このページの工事情報
    const siteInfo = this.props.sites.items.find((item) => (item.koujiBangou === koujiBangou));
    // 工事情報が不正な場合はリストに戻る
    if (!siteInfo) {
      this.props.history.replace('/sitelist');
      return ;
    }
    this.setState({ site: siteInfo });

    this.props.getRecord({
      koujiBangou,
      key: this.props.match.params.key,
      completeHandler: () => {
        // @ts-ignore
      }
    });
  }
  componentWillUnmount() {
    this.props.reset();
  }

  /**
   * データを登録する
   */
  register() {
    // 登録するレコード
    const record = { ...this.props.kansatsuKiroku.item };
    const kansatsuKirokuEditData = this.kansatsuKirokuEditElement.get();
    record.kansatsuDate = kansatsuKirokuEditData.kansatsuDate;
    record.sokutenNumber = kansatsuKirokuEditData.sokutenNumber;
    record.danmenNumber = kansatsuKirokuEditData.danmenNumber;
    record.kyori = kansatsuKirokuEditData.kyori;
    record.kansatsuDateMemo = kansatsuKirokuEditData.kansatsuDateMemo;
    record.sokutenNumberMemo = kansatsuKirokuEditData.sokutenNumberMemo;
    record.danmenNumberMemo = kansatsuKirokuEditData.danmenNumberMemo;
    record.kyoriMemo = kansatsuKirokuEditData.kyoriMemo;
    record.inferenceResultJsonStr = JSON.stringify(record.inferenceResult);
    record.inferenceAdditionalResultJsonStr = JSON.stringify(record.inferenceAdditionalResult);
    record.freeInputs = kansatsuKirokuEditData.freeInputs;
    record.freeInputsJsonStr = JSON.stringify(kansatsuKirokuEditData.freeInputs);
    // このページでは修正のみなのでlastModifiedAtのみ設定
    record.lastModifiedAt = moment().format();

    this.props.postRecord(record, () => {
      // @ts-ignore
    });
  }
  /**
   * データを削除する
   * ここでの削除は論理削除なので、deletedAtに日時を指定してpostする
   */
  delete() {
    if (!confirm('観察記録を削除しますか？')) {
      return;
    }
    // 削除するレコード
    const record = { ...this.props.kansatsuKiroku.item };

    const kansatsuKirokuEditData = this.kansatsuKirokuEditElement.get();
    record.kansatsuDate = kansatsuKirokuEditData.kansatsuDate;
    record.sokutenNumber = kansatsuKirokuEditData.sokutenNumber;
    record.danmenNumber = kansatsuKirokuEditData.danmenNumber;
    record.kyori = kansatsuKirokuEditData.kyori;
    record.kansatsuDateMemo = kansatsuKirokuEditData.kansatsuDateMemo;
    record.sokutenNumberMemo = kansatsuKirokuEditData.sokutenNumberMemo;
    record.danmenNumberMemo = kansatsuKirokuEditData.danmenNumberMemo;
    record.kyoriMemo = kansatsuKirokuEditData.kyoriMemo;
    record.inferenceResultJsonStr = JSON.stringify(record.inferenceResult);
    record.inferenceAdditionalResultJsonStr = JSON.stringify(record.inferenceAdditionalResult);
    record.freeInputs = kansatsuKirokuEditData.freeInputs;
    record.freeInputsJsonStr = JSON.stringify(kansatsuKirokuEditData.freeInputs);

    // 削除時刻のみ設定
    record.deletedAt = moment().format();

    this.props.postRecord(record, () => {
      // @ts-ignore
    });
  }

  render() {
    const site = this.state.site || new SiteInfo();
    const isDeleted = this.props.kansatsuKiroku.item.deletedAt ? true: false;
    return (
    <div>
      <Paper style={{ padding: '10px' }}>
        <Typography variant="h4" style={{ marginBottom: '10px' }}>
          {site.koujiBangou} : {site.name}
        </Typography>
        <div className="command-area">
          <div className="command-area-left">
            <Typography variant="h6">観察記録 { isDeleted ? '　（削除済み） ' : ''}</Typography>
          </div>
          <div className="command-area-right">
            <Typography variant="body2" style={{ color: 'rgba(0,0,0,0.54)', textAlign: 'right' }}>
              作成 {this.props.kansatsuKiroku.item.createdAt ? moment(this.props.kansatsuKiroku.item.createdAt).format('MM/DD HH:mm') : '-'}<br/>
              更新 {this.props.kansatsuKiroku.item.lastModifiedAt ? moment(this.props.kansatsuKiroku.item.lastModifiedAt).format('MM/DD HH:mm') : '-'}
            </Typography>
          </div>
        </div>
        <Paper
          style={styles.contentBase}
        >
          <KansatsuKirokuEdit
            disabled={isDeleted}
            data={this.props.kansatsuKiroku.item}
            ref={(r) => {
              if (r) {
                this.kansatsuKirokuEditElement = r;
              }
            }}
          />
          <Button
            variant="contained"
            color="secondary"
            fullWidth
            onClick={() => this.register()}
            disabled={isDeleted}
          >
            <CloudUpload style={{ marginRight: '5px'}}/>
            観察記録を保存
          </Button>
        </Paper>

        <Typography variant="h6">診断画像</Typography>
        <Paper
          style={styles.contentBase}
        >
          {
            (this.props.kansatsuKiroku.item.croppedImageSignedUrl)
              ? <img src={this.props.kansatsuKiroku.item.croppedImageSignedUrl} />
              : <div>診断画像なし</div>

          }
        </Paper>

        <Typography variant="h6">診断結果</Typography>
        <Paper
          style={styles.contentBase}
        >
          {
            this.props.kansatsuKiroku.item.inferenceResult
              ? <InferenceResultView
                  result={this.props.kansatsuKiroku.item.inferenceResult}
                  additionalResult={this.props.kansatsuKiroku.item.inferenceAdditionalResult}
                />
              : <div>診断結果なし</div>

          }
        </Paper>
        <div
          style={{ paddingLeft: '20px' }}
        >
          <ReactToPrint
            // @ts-ignore
            trigger={() => {
              return (
                <Button
                  variant="contained"
                >
                  <Print style={{ marginRight: '5px'}}/>
                  印刷
                </Button>
              );
            }}
            content={() => this.printTargetRef}
            // 印刷のタイトル、環境によってはPDF保存時のファイル名のデフォルトになる
            documentTitle="観察簿"
          />
        </div>
        <div className="command-area">
          <div className="command-area-left">
            <CloseBackButton history={this.props.history} />
          </div>
          <div className="command-area-right">
            <Button
              variant="contained"
              color="secondary"
              onClick={() => this.delete()}
              disabled={isDeleted}
            >
              <DeleteForever style={{ marginRight: '5px'}}/>
              観察記録を削除
            </Button>
          </div>
        </div>
      </Paper>
      {/* データ印刷領域 */}
      <div
        style={{
          display: 'none'
        }}
      >
        <div  ref={(el) => this.printTargetRef = el}>
          <PrintKansatsuKiroku siteInfo={site} kansatsuKiroku={this.props.kansatsuKiroku.item} />
        </div>
      </div>
    </div>
    );
  }
}

function mapDispatchToProps(dispatch: Dispatch<Action<any>>) {
  return {
    getRecord: ({ koujiBangou, key, completeHandler }) => {
      kansatsuKirokuOperations.get({ koujiBangou, key })(dispatch)
        .then(() => completeHandler());
    },
    postRecord: (record, completeHandler) => {
      kansatsuKirokuOperations.post(record)(dispatch)
        .then(() => completeHandler());
    },
    reset: () => {
      kansatsuKirokuOperations.resetRecord()(dispatch);
    }
  };
}

function mapStateToProps(appState: IAppState) {
  return {
    user: appState.user,
    sites: appState.siteInfoList,
    kansatsuKiroku: appState.kansatsuKiroku
  };
}
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(EditKansatsuKirokuPage);



// WEBPACK FOOTER //
// ./src/components/EditKansatsuKirokuPage.tsx